import React, {Fragment, useContext,useState, useEffect} from 'react'
import './styles/_header.scss';
import { InfoContext } from '../../../context/Context';
import StoreDetails from './components/StoreDetails';
import Buttons from './components/Buttons';
import {InternationalNumber, returnImg } from '../../../selectors/getType'; 
import Hours from './components/Hours';
import ShortForm from '../../sections/ShortForm/ShortForm';
 

export default function Header() {  
    const { data, store, storeUberall} = useContext(InfoContext);
    const [brand, setBrand] = useState(false); 
    const [showModal, setShowModal] = useState(false);
    const [storeId, setStoreId] = useState(null);
    useEffect(() => {
        if(store !== undefined){ 
            if(data.momentFeed.name === "Check Into Cash" ||  data.momentFeed.name === "Easy Money" ||  data.momentFeed.name === "CheckSmart"  ){
                setBrand(true);
            } 
        }
    }, [store])
    const renderHead = () => {
    let picture = returnImg(data.momentFeed.name );
    const result = storeUberall.customFields.filter(custom => custom.name === 'store_image');
    if(result.length > 0 && result[0].value !=""){
        picture = result[0].value;
    }

    const handleGetStarted = (storeId) => {
        setStoreId(storeId);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
      };
    let phone_number = InternationalNumber(storeUberall.phone);
    const google = `https://maps.google.com/?q=:${storeUberall.streetAndNumber} ${storeUberall.city}  ${storeUberall.province}  ${storeUberall.zip}`;
        return(
            <Fragment>
                <section id="storeContent" itemScope="" itemType="https://schema.org/Store">
                    <div className="cic-rate-state-wrapper">
                        <div className="rate-state-background">
                            <img itemProp="image" src={`${picture}`} alt={`Store in  ${data.momentFeed.name} ${data.momentFeed.locality}, ${data.momentFeed.state_min}`} />
                        </div>
                        <div className="rate-state-info">
                            <div className="rate-state-title">
                                <h1 itemProp="name"> {data.momentFeed.name} {data.momentFeed.locality}, {data.momentFeed.state_min} </h1>
                            </div>
                            <div className="rate-state-table">
                                <h2 className="txtLeft h2-sub"> {data.momentFeed.locality}, {data.momentFeed.state_min} </h2>
                                <StoreDetails 
                                    topTel="topTel" 
                                    icon="IconPhone" 
                                    url={`tel:${storeUberall.phone}`} 
                                    aria={`Call Us at ${phone_number}`} 
                                    text={phone_number} 
                                    type="address" 
                                    schema="https://schema.org/PostalAddress" 
                                />

                                <StoreDetails 
                                    topTel="" 
                                    icon="IconMapPin" 
                                    url={google} 
                                    aria={`get the Google Map directions`} 
                                    text={`${storeUberall.streetAndNumber}, ${storeUberall.city}, ${storeUberall.province}, ${storeUberall.zip} `} 
                                    type="address" 
                                    schema="https://schema.org/PostalAddress" 
                                />
                                {
                                    (storeUberall.sublocality === "" || storeUberall.sublocality === undefined) 
                                    ? <></> 
                                    : (
                                        <StoreDetails 
                                            topTel="" 
                                            icon="IconBuilding" 
                                            url={google} 
                                            aria={`get the Google Map directions`} 
                                            text={`${storeUberall.sublocality} `} 
                                        />
                                    )
                                }
                                <Hours store={storeUberall}/>
                            </div>
                            <div className="rate-state-buttons" itemScope="" itemProp="hasMap" itemType="https://schema.org/Map">
                                <button 
                                    onClick={() => handleGetStarted(storeUberall.identifier)} 
                                    className="cic-btn cic-btn-get-started my-3" 
                                    aria-label="Click here to apply for a California Check Cashing Stores Payday Loan now"> 
                                    Get Started Online
                                </button>
                                <Buttons link={google} btn="cic-btn-secondary--dark" aria="Click here to get the directions from this store" text={`Get Directions`} item="mapType"  /> 
                            </div>
                            <div className="rate-state-callus">
                                <p className="cic-paragraph--medium ml-2">
                                    <a title="Back to Stores List" rel="noopener noreferrer" aria-label="Back to Stores List" href="/us/">Back to Stores List</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    (showModal === true) ?
                        (  <ShortForm 
                            storeId={storeId}
                            zip={storeUberall.zip}
                            showModal={showModal} 
                            handleCloseModal={handleCloseModal} 
                        />) 
                        : 
                        <></>
                }
            </Fragment>
        )
    }
  return (
    <Fragment> 
        {
             ( typeof data === 'object' && storeUberall !== null && data !== null) ? ( renderHead() )  : <></>
        } 
    </Fragment>
  )
}
